const class_wrapper_image = 'collection-blogs-wrapper__media';
const class_wrapper_image__darken = 'collection-blogs-wrapper__media--darken';
const class_wrapper_title_arrow = 'collection-blogs-wrapper__content__title__arrow';
function displayImageAnimation() {
    var image_object;
    var arrow_object =this.parentNode;
    arrow_object = arrow_object.parentNode;
    image_object = arrow_object.getElementsByClassName(class_wrapper_image)[0];
    image_object.classList.add(class_wrapper_image__darken);
    if(arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0] != null){
        arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0].style.display = "block";
    }
}

function removeImageAnimation() {
    var image_object;
    var arrow_object =this.parentNode;
    arrow_object = arrow_object.parentNode;
    image_object = arrow_object.getElementsByClassName(class_wrapper_image)[0];
    image_object.classList.remove(class_wrapper_image__darken);
    if(arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0] != null){
        arrow_object = arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0].style.display = "none";
    }
}

function displayTextAnimation() {
    var image_object;
    var arrow_object =this.parentNode;
    arrow_object = arrow_object.parentNode;
    arrow_object = arrow_object.parentNode;
    image_object = arrow_object.getElementsByClassName(class_wrapper_image)[0];
    image_object.classList.add(class_wrapper_image__darken);
    if(arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0] != null){
        arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0].style.display = "block";
    }
}

function removeTextAnimation() {
    var image_object;
    var arrow_object =this.parentNode;
    arrow_object = arrow_object.parentNode;
    arrow_object = arrow_object.parentNode;
    image_object = arrow_object.getElementsByClassName("collection-blogs-wrapper__media")[0];
    image_object.classList.remove("collection-blogs-wrapper__media--darken");
    if(arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0] != null){
        arrow_object = arrow_object.getElementsByClassName(class_wrapper_title_arrow)[0].style.display = "none";
    } 
}